import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import {previewBlock} from '../../../../../api/cp';
import {Modal} from 'react-bootstrap';

const BlocksModalPreview = ({isModalVisible, block, background = 'black', onHide}) => {
    const [htmlBlock, setHtmlBlock] = useState(null);

    useEffect(async() => {
        if (isModalVisible) {
            const data = await previewBlock(block.id);

            setHtmlBlock(data);
        } else {
            setHtmlBlock(null);
        }

    }, [isModalVisible]);

    return (
        <Modal
            show={isModalVisible && !!htmlBlock}
            onHide={() => onHide(false)}
            className="blocks-modal-preview"
        >
            <Modal.Body>
                <div style={{display: 'flex', justifyContent: 'center', padding: '16px', background}}>
                    <div style={{width: '100%'}}>
                        {
                            htmlBlock && parse(htmlBlock)
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default BlocksModalPreview;
